import axios from 'axios';

// 设置 API 的基础 URL
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axios;

// 获取交易记录
export const getTrades = async (params) => {
    const response = await axios.get('/api/trades', { params });
    return response.data;
};

// 获取持仓列表
export const getPositions = async () => {
    const response = await axios.get('/api/positions');
    return response.data;
};

// 更新持仓
export const updatePosition = async (id, data) => {
    const response = await axios.put(`/api/positions/${id}`, data);
    return response.data;
};

// 获取期货配置
export const getFuturesConfig = async () => {
    const response = await axios.get('/api/futures-config');
    return response.data;
};

// 添加期货配置
export const addFuturesConfig = async (data) => {
    const response = await axios.post('/api/futures-config', data);
    return response.data;
};

// 更新期货配置
export const updateFuturesConfig = async (id, data) => {
    const response = await axios.put(`/api/futures-config/${id}`, data);
    return response.data;
};

// 删除期货配置
export const deleteFuturesConfig = async (id) => {
    const response = await axios.delete(`/api/futures-config/${id}`);
    return response.data;
};